import jQuery from "jquery";
import 'bootstrap';

window.$ = window.jQuery = jQuery;

$.fn.showLoading = function () {
    $('#loading').attr('aria-hidden', 'true');
};

$.fn.hideLoading = function () {
    $('#loading').attr('aria-hidden', 'false');
};



// WEBPACK FOOTER //
// ./resources/assets/user/js/app.js